import React, {Component} from 'react';
import {Table} from 'react-data-components';
import api from '../../utils/api';
import moment from 'moment';
import SortableQuiz from '../EditChapterPart/SortableQuiz';
import CsvParse from '@vtex/react-csv-parse';
import CsvDownloader from 'react-csv-downloader';
import { Scrollbars } from 'react-custom-scrollbars';
import ReactQuill from 'react-quill'; // ES6
import 'react-quill/dist/quill.snow.css'; // ES6
import {withRouter} from 'react-router-dom';

/* global $ */

const testTemplate = {
    title: '',
    show_description: '',
    instructions: '',
    course: '',
    type: '',
    subject: '',
    sections: [
        {name: '', questions: [], subjectId: ''}
    ]
}



class EditTest extends Component {
    state = {
        columns: [],
        activeCourse: {},
        activeSection: 0,
        currentTab: 0,
        uploadQuestions: [],
        showUploadModal: false,
        test: {}
    };

    //Renders
    renderOptions = (val, row) => {
        return (
            <div className="dropdown">
                <a href="nogo"
                   data-toggle="dropdown"
                   className="btn btn-default"
                >
                    Options
                </a>
                <ul className="dropdown-menu">
                    {window.location.href.indexOf('tests') === -1 ?
                        <li>
                            <a href="nogo" onClick={(e) => {
                                e.preventDefault();
                                this.props.setTest(row);
                            }}>
                                <i className="zmdi zmdi-plus-circle"/> Set as Courses Test
                            </a>
                        </li>
                    : null}
                    {/*
                    <li>
                        <a href="nogo" onClick={(e) => {
                            e.preventDefault();
                            let test = JSON.parse(JSON.stringify(row));
                            delete test.id;
                            test.title = test.title + " (copy)";
                            this.props.saveTest(test, this.props.user.id);
                        }}>
                            <i className="zmdi zmdi-copy"

                            /> Copy Test
                        </a>
                    </li>
                    */}
                    <li>
                        <a href="nogo"  onClick={(e) => {
                            e.preventDefault();
                            this.setState({activeCourse: this.props.courses.filter(c => c.id === JSON.parse(JSON.stringify(row)).courseId)[0], currentTab: 1}, () => {
                                this.props.updateTest(JSON.parse(JSON.stringify(row)));
                                this.props.history.push('/tests/' + row.id);
                            });
                        }}>
                            <i className="zmdi zmdi-edit"
                            /> Edit Test
                        </a>
                    </li>
                    {/*
                    <li>
                        <a href="nogo" onClick={(e) => {
                            e.preventDefault();
                            this.setState({test: testTemplate, currentTab: 1});
                        }}>
                            <i className="zmdi zmdi-plus-circle"/> Add Test
                        </a>
                    </li>
                    */}
                    <li>
                        <a href="nogo" onClick={(e) => {
                            e.preventDefault();
                            this.props.deleteTest(row.id, this.props.user.id);
                        }}>
                            <i className="zmdi zmdi-delete" /> Delete
                        </a>
                    </li>
                </ul>
            </div>
        )
    }
    
     uploadSectionFile = (e, sectionIndex, index) => {
        if(e.target.files.length > 0){
            const data = new FormData();
            data.append('file', e.target.files[0], this.props.profile.id + "-" + new Date().getTime().toString() + "-" + e.target.files[0].name);

            this.props.uploadFile(data, this.props.profile.id, {f: "section", index: index, sectionIndex: sectionIndex}, this.props.user.id);
         }

    }
    
     uploadFile = (e, sectionIndex, index) => {
        if(e.target.files.length > 0){
            const data = new FormData();
            data.append('file', e.target.files[0], this.props.profile.id + "-" + new Date().getTime().toString() + "-" + e.target.files[0].name);

            this.props.uploadFile(data, this.props.profile.id, {f: "question", index: index, sectionIndex: sectionIndex}, this.props.user.id);
         }

    }

    modules = {
        toolbar: [
            ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
          
            [{ 'header': 1 }, { 'header': 2 }],               // custom button values
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
            [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent                  // text direction
          
            [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown

          
            [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
          
            ['clean']            
        ],
      }
    
      formats = [
        'header',
        'bold', 'italic', 'underline', 'strike', 'blockquote', 'script',
        'list', 'bullet', 'indent',
        'link', 'image', 'color', 'code-block'
      ]

    renderInstructions = () => {
        return (
            <div className="col-md-12 test-quill">

                        
                        <ReactQuill 
                            value={this.props.test.instructions || ''}
                            modules={this.modules}
                            placeholder={'Instructions'}
                            formats={this.formats}
                            onChange={(val) => {
                                let {test} = this.props;
                                test.instructions = val;
                                this.setState({test})
                            }}
                        />

            </div>
        )
        
    }

    renderSectionInstructions = () => {
        return (
            <div className="col-md-12 test-quill">
                    <label>Instructions</label> 
                        <ReactQuill 
                            value={this.props.test.sections[this.state.activeSection].instructions || ''}
                            modules={this.modules}
                            placeholder={'Instructions'}
                            formats={this.formats}
                            onChange={(val) => {
                                this.props.updateSectionField(this.state.activeSection, 'instructions', val);
                            }}
                        />

            </div>
        )
        
    }

    renderQuestionForm = (s, i, q, field, label, letter) => {
        return (
            <div className="col-sm-12 test-quill">
                <div className="row">
                    <div className="col-md-1 checkbox-left">
                        {field.indexOf('option') > -1 ?
                                            
                        <label>
                            <div
                                className={`iradio_square video-modal-radio-wrapper ${q.correctOption === letter && 'checked'}`}
                            >
                                <input
                                    type="radio"
                                    name="radio"
                                    value="60"
                                    className='video-modal-radio'
                                    onChange={e => this.props.updateQuestion(this.state.activeSection, i, 'correctOption', letter)}
                                />
                                <ins className="iCheck-helper video-modal-radio-icon"/>
                            </div>
                        </label>
                        : null}
                    </div>
                
                    <div className="col-md-10">
                        {!letter ?
                            <label class="quill-label">{label}</label>
                        : null}
                    
                        <ReactQuill 
                            value={q[field] || ''}
                            modules={field === 'question' ? this.modules : {toolbar: false}}
                            placeholder={label}
                            formats={this.formats}
                            onChange={val => this.props.updateQuestion(this.state.activeSection, i, field, val)} 
                        />
                    </div>
                </div>
            </div>
        )
        
    }


    renderQuestions = (sections) => {
        const options = ["A", "B", "C", "D"];
        if(Number(this.state.test.answer_choices) === 5){
            options.push("E");
        }

        if(this.props.test.testType === 'answer' && sections[this.state.activeSection]){
            return sections[this.state.activeSection].questions.map((item, index) => (
                <div className="table-question sm-bottom0" key={index}>
                    <div className="table-question-row">
                        <ul>
                            <li className="question-number"><input type="text" className="form-control AnswerSheetQuestionNumber" readOnly={true} value={index + 1} /> </li>
                            <li className="QuestionAble">
                                <input type="radio" id={`${this.state.activeSection}-${index}-Option1A`} name="Question1" value="A" onClick={e => {
                                    e.preventDefault();
                                    this.props.updateQuestion(this.state.activeSection, index, 'correctOption', e.target.value);
                                }} />
                                <label htmlFor={`${this.state.activeSection}-${index}-Option1A`} className={item.correctOption === 'A' ? 'active' : ''}>A</label>
                                <div className="selected"></div>
                            </li>
                            <li className="QuestionAble">
                                <input type="radio" id={`${this.state.activeSection}-${index}-Option1B`} name="Question1" value="B" onClick={e => {
                                    e.preventDefault();
                                    this.props.updateQuestion(this.state.activeSection, index, 'correctOption', e.target.value);
                                }}/>
                                <label htmlFor={`${this.state.activeSection}-${index}-Option1B`} className={item.correctOption === 'B' ? 'active' : ''}>B</label>
                                <div className="selected"></div>
                            </li>
                            <li className="QuestionAble">
                                <input type="radio" id={`${this.state.activeSection}-${index}-Option1C`} name="Question1" value="C" onClick={e => {
                                    e.preventDefault();
                                    this.props.updateQuestion(this.state.activeSection, index, 'correctOption', e.target.value);
                                }}/>
                                <label htmlFor={`${this.state.activeSection}-${index}-Option1C`} className={item.correctOption === 'C' ? 'active' : ''}>C</label>
                                <div className="selected"></div>
                            </li>
                            <li className="QuestionAble">
                                <input type="radio" id={`${this.state.activeSection}-${index}-Option1D`} name="Question1" value="D" onClick={e => {
                                    e.preventDefault();
                                    this.props.updateQuestion(this.state.activeSection, index, 'correctOption', e.target.value);
                                }} />
                                <label htmlFor={`${this.state.activeSection}-${index}-Option1D`} className={item.correctOption === 'D' ? 'active' : ''}>D</label>
                                <div className="selected"></div>
                            </li>
                            {Number(this.state.test.answer_choices) === 5 &&
                            <li className="QuestionAble">
                                <input type="radio" id={`${this.state.activeSection}-${index}-Option1E`} name="Question1" value="E" onClick={e => {
                                    e.preventDefault();
                                    this.props.updateQuestion(this.state.activeSection, index, 'correctOption', e.target.value);
                                }} />
                                <label htmlFor={`${this.state.activeSection}-${index}-Option1E`} className={item.correctOption === 'E' ? 'active' : ''}>E</label>
                                <div className="selected"></div>
                            </li>
                            }
                            <li className="question-number"><a href="nogo" className="" onClick={(e) => {
                                        e.preventDefault();
                                        this.props.deleteQuestion({sectionIndex: this.state.activeSection, index: index});
                                    }}><i className="zmdi zmdi-delete"></i> </a></li>

                        </ul>
                    </div>
                </div>
                ))
        }else{
            if(this.state.activeSection >= 0 && sections[this.state.activeSection]){
                return sections[this.state.activeSection].questions.map((item, index) => (
                    <div
                        key={index}
                        className="panel customPanel test-panel"
                    >

                        <h3 className="panel-title font-400">
                           
                                <a
                                    href="nogo"
                                    className="btn btn-transparent pull-right"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        this.props.deleteQuestion({sectionIndex: this.state.activeSection, index: index});
                                    }}
                                >
                                    <i className="zmdi zmdi-delete "/>
                                </a>
                            
                            <span className="font-16">
                                <a 
                                    href={`#sub-${this.state.activeSection}-${index}`} 
                                    data-toggle="collapse" className="text-white" 
                                    dangerouslySetInnerHTML={{__html: item.question ? (index + 1).toString() + '. ' + item.question : (index + 1).toString() + '. ' + 'Untitled Question'}}>
                                </a>
                            </span>
                           
                        </h3>
                        
                        <div className="panel-body bg-light-2 collapse" id={`sub-${this.state.activeSection}-${index}`}>
                            
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="row">
                                        {this.props.test.sections[this.state.activeSection].file ?
                                        <div className="col-md-4">
                                            
                                                <div className="pdfPage">
                                                    <label className="">PDF Page #</label>
                                                    <input 
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Page in PDF" 
                                                        value={item.page} 
                                                        onChange={e => this.props.updateQuestion(this.state.activeSection, index, 'page', e.target.value)}
                                                    />
                                                    <label>Write the page number (x), page range (x-y), comma-separated pages for specific pages(x,y), or all (x-y, z)</label>
                                                </div>
                                            
                                        </div>
                                        : null}
                                        <div className="col-md-8">
                                            {this.renderQuestionForm(this.state.activeSection, index, item, 'concept', 'Concept', null)}
                                    
                                        </div>
                                    </div>
                                    <br/>
                                    {this.renderQuestionForm(this.state.activeSection, index, item, 'question', 'Write your question', null)}
                                    <br/>
                                    {this.renderQuestionForm(this.state.activeSection, index, item, 'hint', 'Hint', null)}
                                    <br/><br />
                                    {options.map((o, oi) => {
                                        return this.renderQuestionForm(this.state.activeSection, index, item, 'option' + o, 'Answer Option ' + o, o)
                                    })}
                                    
                                    
                                    
                                    
                                    {["quiz", "mcat"].indexOf(this.props.test.testType) > -1 &&
                                        
                                               
                                                <div className="">
                                                {item.image &&
                                                    <img
                                                        className="test-question-image"
                                                        src={api.makeFileURL(item.image, this.props.user.id)}
                                                        alt="user"
                                                    />
                                                  
                                                }
                                                <br />
                                                    <span className="btn btn-default btn-file">
                                                        <span className="fileinput-new">
                                                            <i className="zmdi zmdi-upload"/>
                                                            {item.image ?
                                                                'Replace Image'
                                                                :
                                                                'Upload Image'
                                                            }
                                                        </span>
                                                        
                                                        <input
                                                            type="file"
                                                            onChange={e => this.uploadFile(e, this.state.activeSection, index)}
                                                            accept="image/*" 
                                                        />
                                                    </span>
                                                </div>
                                             
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                ))
            }
        }
    }

    saveTest = () => {
        
        let test = JSON.parse(JSON.stringify(this.props.test));


        let finish = test.finish;
        if(typeof(finish) === "string"){
            if(finish.indexOf(':') > -1){
        
                if(finish.split(":").length === 3) {
                    finish = moment.duration(finish).asSeconds();
                }else if(finish.split(":").length === 2){
                    finish = moment.duration("00:" + finish).asSeconds()
                }else{
                    finish = moment.duration("00:00:" + finish).asSeconds()
                }
        
                test.finish = finish;
            }
        }

        let timeLimit = test.timeLimit;
        if(typeof(timeLimit) === "string"){
            if(timeLimit.indexOf(':') > -1){
        
                if(timeLimit.split(":").length === 3) {
                    timeLimit = moment.duration(timeLimit).asSeconds();
                }else if(timeLimit.split(":").length === 2){
                    timeLimit = moment.duration("00:" + timeLimit).asSeconds()
                }else{
                    timeLimit = moment.duration("00:00:" + timeLimit).asSeconds()
                }
        
                test.timeLimit = timeLimit;
            }
        }
        
        if(this.props.diagnosticTestId){
            this.props.saveDiagnosticTest(test, this.props.user.id);
        }else{
            this.props.saveTest(test, this.props.user.id);
            this.setState({currentTab: 0, test: testTemplate, activeSection: 0});
        }
    }

    componentDidUpdate(props){
        if(this.props.test.id){
            if(this.props.test.sections[this.state.activeSection] && props.test.sections[this.state.activeSection]){
                if(this.props.test.sections[this.state.activeSection].questions && props.test.sections[this.state.activeSection].questions){
                    if(this.props.test.sections[this.state.activeSection].questions.length !== props.test.sections[this.state.activeSection].questions.length){
                        // console.log("Collapse",this.props.test.sections[this.state.activeSection].questions.length);
                        if(this.props.test.sections[this.state.activeSection].questions.length){
                            $(`.collapse`).collapse('hide');
                            $(`#sub-${this.state.activeSection}-${this.props.test.sections[this.state.activeSection].questions.length - 1}`).collapse('show');
                        }
                    }
                
                }
            }
            if(this.props.test.id !== props.test.id && this.state.currentTab !== 1){
                // console.log("loaded new test info");
                this.setState({currentTab: 1});
            }
        }
    }

    renderCourse = (val, row) => {
        return (
            <div>
                {row.Course ? row.Course.name ? row.Course.name : '' : ''}
            </div>
        )
    }

    renderSubject = (val, row) => {
        return (
            <div>
                {row.Subject ? row.Subject.name ? row.Subject.name : '' : ''}
            </div>
        )
    }

    //Lifecycle
    componentDidMount(props) {
        this.setState({
            columns: [
                {title: 'Course', prop: 'id', render: this.renderCourse},
                {title: 'Subject', prop: 'id', render: this.renderSubject},
                {title: 'Title', prop: 'name'},
                {title: 'Options', prop: 'id', render: this.renderOptions}
            ]
        })
        
        this.props.loadTestTemplates(this.props.user.id);
        
        if(this.props.diagnosticTestId){
            this.props.loadDiagnosticTest(this.props.diagnosticTestId, this.props.user.id);
        }else
        if(this.props.match.params.chapterTestId){
            this.props.loadChapterTest(this.props.match.params.chapterTestId, this.props.user.id);
        }
    }
    
    setDiagnosticSections = (test) => {
        
        let course = this.props.courses.filter(c => c.id === test.courseId);
        if(course.length > 0){
            course = course[0];
            test.sections = [];
            if(course.CourseSubject && this.props.test.testLocation !== 'content'){
                course.CourseSubject.map(sub => {
                    return test.sections.push({name: sub.name, questions: [], subjectId: sub.id})
                })
                this.setState({test: test});
            }
            
        }
        
    }
    
    componentWillUpdate = (props, state) => {
        if(this.state.currentTab === 0 && ((this.props.test.courseSubjectId && this.props.match.params.chapterTestId) || this.props.diagnosticTestId)){
            this.setState({currentTab: 1});
        }
        
        if(state.activeCourse !== props.activeCourse && !state.activeCourse.id){
            this.setState({activeCourse: props.activeCourse});
        }
        if(this.state.test && state.activeCourse){
            if(!state.activeCourse.id && state.test.courseId){
                let course = props.courses.filter(c => c.id === state.test.courseId);
                if(course){
                    course = course[0];
                    this.setState({activeCourse: course});
                }
            }
            if((state.test.testLocation === 'diagnostic' && this.state.test.testLocation !== 'diagnostic' && state.test.courseId) ||
            (state.test.courseId !== this.state.courseId && state.test.courseId && state.test.testLocation && state.test.testLocation === 'diagnostic')){
                if(state.test.sections.length === 1 && state.test.sections[0].questions.length === 0){
                    this.setDiagnosticSections(state.test);
                }
            }
        }
    }


    
    renderHeaderPage = () => (
        <div className="bg-light lter b-b wrapper-md">
            <div className="row">
                <div className="col-sm12 col-xs-12">
                    <h1 className="m-n font-thin h3 text-black">
                        Tests
                    </h1>
                    <small className="text-muted">
                        Manage all tests
                    </small>
                </div>
            </div>
        </div>
    )
    

    handleData = data => {
        data = data.map((d, i) => {
            return {
                ...d,
                conceptName: d.conceptName ? d.conceptName : '',
                correctOption: d.correctOption ? d.correctOption : "A",
                page: d.page ? d.page : '',
                number: i
            
            }
        })
        // console.log("handling data", data);
      this.setState({ uploadQuestions: data })
    }

    handleQuestionUpload = () => {
        let {uploadQuestions} = this.state;
        uploadQuestions = uploadQuestions.map((q, i) => {
            return {
                ...q,
                number: this.props.test.sections[this.state.activeSection].questions.length + i
            }
        })
        
        uploadQuestions.map(q => {
            return this.props.addTestQuestionWithData(q, this.state.activeSection);
        })
        
        this.setState({showUploadModal: false, uploadQuestions: []});
    }

    keys = [
        "question",
        "optionA",
        "optionB",
        "optionC",
        "optionD",
        "optionE",
        "correctOption",
        "conceptName",
        "page",
        "hint"
        ]

    renderUploadModal = () => {
        return (
            <div className='delete-modal-wrapper bootbox modal fade bootbox-confirm in'>
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-body">
                        <button
                            type="button"
                            className="bootbox-close-button close"
                            data-dismiss="modal"
                            aria-hidden="true"
                            onClick={(e) => this.setState({showUploadModal: false, uploadQuestions: []})}
                        >
                            ×
                        </button>
                        <div className="bootbox-body">
                            <h4 className="modal-title">Import Quiz Questions</h4>
                            <Scrollbars style={{ height: "80vh", overflow: "hidden"}}>
                            <div className="sp-10 font-16 modalScroll">
                                {this.state.uploadQuestions.length === 0 &&
                                    <CsvParse
                                      keys={this.keys}
                                      onDataUploaded={this.handleData}
                                      onError={this.handleError}
                                      render={onChange => (
                                            <div className="upload-body">
                                                <button className="btn btn-primary" onClick={e => {
                                                    $('#qqu').trigger('click');
                                                }}
                                                ><i className="zmdi zmdi-upload" /> &nbsp; Select File</button>
                                                <input id="qqu" type="file" onChange={onChange} className="hide" />
                                            </div>
                                        )
                                      }
                                    />
                                }
                                <SortableQuiz
                                    questions={this.state.uploadQuestions}
                                    handleEditQuestionClick={this.handleEditQuestionClick}
                                    handleDeleteModalShowState={this.props.handleDeleteModalShowState}
                                    handleRewindTo={this.handleRewindTo}
                                    isEditedInPreview={this.state.isEditedInPreview}
                                    updateQuestionNumbers={e => {}}
                                    uploadQuestions={true}
                                    
                                />
                            </div>
                            </Scrollbars>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-default"
                            onClick={(e) => this.setState({showUploadModal: false, uploadQuestions: []})}
                        >
                            Close
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={this.handleQuestionUpload}
                            
                        >
                            Import
                        </button>
                    </div>
                </div>
            </div>
        </div>    
        )
    }
    
    render() {
        
            
        return (
            <div className="content-wrapper" id="content-container">
            {!this.props.diagnosticTestId && this.renderHeaderPage()}
            <section className="content">
                <div>
                    <div className="">
                        <div className="p50">
                            <div className="nav-tabs-custom no-bg">
                            {!this.props.test.courseSubjectId && !this.props.diagnosticTestId && true === false &&
                                <ul className="nav nav-tabs bg-white" style={{background: '#1f1f1f !important'}}>
                                    <li className={this.state.currentTab === 0 ? "active" : ""}>
                                        <a href="#tab_21" data-toggle="tab" onClick={(e) => {
                                            e.preventDefault();
                                            this.setState({currentTab: 0}, () => {
                                                this.props.resetTestTemplate();
                                            });
                                        }}>
                                            Saved Tests
                                        </a>
                                    </li>
                                    <li className={this.state.currentTab === 1 ? "active" : ""}>
                                        <a href="#tab_22" id="editTestTrigger" data-toggle="tab" onClick={(e) => {
                                            e.preventDefault();
                                            this.setState({currentTab: 1});
                                        }}>
                                            Add Test
                                        </a>
                                    </li>
                                </ul>
                            }
                                <div className="tab-content no-padding admin-test-container">
                                    <div className={!this.props.match.params.chapterTestId ? "tab-pane active no-padding tickets-table" : "tab-pane no-padding tickets-table"} id="tab_21">
                                        {this.props.testTemplates.length > 0 && this.state.columns.length > 0 ?
                                            <Table
                                                className="table table-bordered table-striped"
                                                keys="id"
                                                dataArray={this.props.testTemplates}
                                                columns={this.state.columns }
                                            />
                                            : <h4>Add a test to get started</h4>}
                                    </div>
                                    <div className={this.props.match.params.chapterTestId ? "tab-pane active no-padding" : "tab-pane no-padding"}  id="tab_22">
                                        <div className="form-group">
                                            {/* Top panel */}
                                            <div className="panel customPanel sm-top20">
                                                <div className="panel-heading" style={{background: "#9b291e", color: "#fff"}}>
                                                    <h3 className="panel-title"><i className="zmdi zmdi-edit"></i> Test Information</h3>
                                                </div>
                                                <div className="panel-body">
                                                    <div className="row">
                                                        <div className="col-sm-3">
                                                            <div className="form-group">
                                                                <label>Course</label>
                                                                <select className="form-control"
                                                                    value={this.props.test.courseId}
                                                                        onChange={(e) => {
                                                                            let course = this.props.courses.filter(course => course.id === e.target.value)[0];
                                                                            if(course) {
                                                                                let {test} = this.props;
                                                                                test.courseId = e.target.value;
                                                                                test.course = course.name;
                                                                                this.setState({test, activeCourse: course});
                                                                            }
                                                                        }}
                                                                >
                                                                    <option value="">Choose</option>
                                                                    {this.props.courses.map(course => {
                                                                        return <option value={course.id}>{course.name}</option>;
                                                                    })}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label>Test Type</label>
                                                                <select className="form-control"
                                                                    value={this.props.test.testLocation}
                                                                        onChange={(e) => {
                                                                            let {test} = this.props;
                                                                            test.testLocation = e.target.value;
                                                                            this.setState({test})
                                                                        }}
                                                                >
                                                                    <option value="">Select</option>
                                                                    <option value="content">Course Test</option>
                                                                    <option value="diagnostic">Diagnostic Test</option>
                                                                </select>
                                                            </div>
                                                        </div>
        
                                                        <div className="col-sm-3">
                                                            <div className="form-group">
                                                                <label>View Type</label>
                                                                <select className="form-control"
                                                                    value={this.props.test.testType}
                                                                        onChange={(e) => {
                                                                            let {test} = this.props;
                                                                            test.testType = e.target.value;
                                                                            this.setState({test})
                                                                        }}
                                                                >
                                                                    <option value="">Select</option>
                                                                    <option value="answer">Answer Sheet</option>
                                                                    <option value="quiz">Quiz</option>
                                                                    <option value="mcat">MCAT Style Answer Sheet</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        
                                                        <div className="col-sm-3">
                                                            <div className="form-group">
                                                                <label>Show Description</label>
                                                                <select className="form-control"
                                                                    value={this.props.test.show_description}
                                                                        onChange={(e) => {
                                                                            let {test} = this.props;
                                                                            test.show_description = e.target.value;
                                                                            this.setState({test})
                                                                        }}
                                                                >
                                                                    <option value="yes">Yes</option>
                                                                    <option value="no">No</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="row ml-0 mr-0">
                                                        <div className="col-sm-6">
                                                            <div className="form-group">
                                                                <label>Title</label>
                                                                <input type="text" className="form-control"
                                                                    value={this.props.test.name || ''}
                                                                       onChange={(e) => {
                                                                           let {test} = this.props;
                                                                           test.name = e.target.value;
                                                                           this.setState({test})
                                                                       }}
                                                                />
                                                            </div>
                                                        </div>
                                                        
                                                        <div className={"col-sm-3"}>
                                                            <label>Target Time (For Efficiency)</label>
                                                            <input className="form-control"
                                                                   value={this.props.test.finish}
                                                                   onChange={(e) => {
                                                                        let {test} = this.props;
                                                                        test.finish = e.target.value;
                                                                        this.setState({test});
                                                                   }}
                                                                   />
                                                        </div>
                                                        <div className={"col-sm-3"}>
                                                            <label>Time Limit</label>
                                                            <input className="form-control"
                                                                   value={this.props.test.timeLimit}
                                                                   onChange={(e) => {
                                                                        let {test} = this.props;
                                                                        test.timeLimit = e.target.value;
                                                                        this.setState({test});
                                                                   }}
                                                                   />
                                                        </div>
                                                        </div>
                                                        <div className="row ml-0 mr-0">
                                                        <div className="col-sm-3">
                                                            <div className="form-group">
                                                                <label>Answer Choices</label>
                                                                <select className="form-control"
                                                                    value={this.props.test.answer_choices}
                                                                        onChange={(e) => {
                                                                            let {test} = this.props;
                                                                            test.answer_choices = e.target.value;
                                                                            this.setState({test})
                                                                        }}
                                                                >
                                                                    <option value="4">4</option>
                                                                    <option value="5">5</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        
                                                        {this.props.test.courseSubjectId &&

                                                                <div className="col-md-3">
                                                                    <div className="form-group">
                                                                        <label>On Failure</label>
                                                                        <select className="form-control" value={this.props.test.failBehavior} onChange={(e) => {
                                                                                let {test} = this.props;
                                                                                test.failBehavior = e.target.value;
                                                                                this.setState({test})
                                                                            }} >
                                                                        
                                                                            <option value="">Choose</option>
                                                                            <option value="lecture">Retake Test</option>
                                                                            <option value="Subject">Reset Subject</option>
                                                                        </select>
                                                                            
                                                                            
                                                                    </div>
                                                                </div>
                                                        }
                                                        {this.props.test.courseSubjectId &&
                                                                <div className="col-sm-3">
                                                                    <div className="form-group">
                                                                        <label>Mode</label>
                                                                        <select className="form-control"
                                                                            value={this.props.test.testMode}
                                                                                onChange={(e) => {
                                                                                    let {test} = this.props;
                                                                                    test.testMode = e.target.value;
                                                                                    this.setState({test})
                                                                                }}
                                                                        >
                                                                            <option value="">Choose</option>
                                                                            <option value="practice">Practice (untimed)</option>
                                                                            <option value="training">Training Wheels (Semi-Timed)</option>
                                                                            <option value="timed">Timed</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                        }
                                                        {this.props.test.courseSubjectId &&
                                                                
                                                                <div className="col-sm-3">
                                                                    <div className="form-group">
                                                                        <label>Scoring</label>
                                                                        <select className="form-control"
                                                                            value={this.props.test.scoring}
                                                                                onChange={(e) => {
                                                                                    let {test} = this.props;
                                                                                    test.scoring = e.target.value;
                                                                                    this.setState({test})
                                                                                }}
                                                                        >
                                                                            <option value="">Choose</option>
                                                                            <option value="score">80% Score</option>
                                                                            <option value="correct10">10 Correct Questions</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                           
                                                        }
                                                        </div>
        
                                                        <div className="col-sm-12">
                                                            <div className="form-group">
                                                                <label>Instructions</label>
                                                                {this.renderInstructions()}
                                                            </div>
                                                        </div>
                                                        
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            
                                            {/* End top Panel */}
                                            {/* Questions panel */}
                                            
                                            <div className="nav-tabs-custom no-bg inner-tabs">
                                                    
                                                    <ul className="nav nav-tabs">
                                                        {this.props.test.sections.map((section, index) => {
                                                                return (
                                                                    <li className={this.state.activeSection === index ? "active" : ""}><a onClick={(e) => {
                                                                    e.preventDefault();
                                                                    this.setState({activeSection: index});
                                                                }}>{section.name || 'Section ' +  index}</a></li>
                                                                )
                                                            })}
                                                            
                                                            <li><a onClick={(e) => {
                                                                e.preventDefault();
                                                                this.props.addTestSection();
                                                            }}><i className={"zmdi zmdi-plus"}></i></a></li>
                                                    </ul>
                                                        
                                                    </div>
                                                    <br />
                                                    
                                                    
                                            <div className="panel customPanel sm-top20">
                                                <div className="panel-heading" style={{background: "#9b291e", color: "#fff"}}>
                                                    <h3 className="panel-title"><i className="zmdi zmdi-edit"></i> Section Content</h3>
                                                </div>
                                                <div className="panel-body">
                                                
                                                
                                            
                                                    
                                                    {this.props.test.sections[this.state.activeSection] &&
        
                                                    this.state.activeCourse &&
                                                    <div>
        
                                                            <div>
                                                                <input
                                                                    className="form-control"
                                                                    value={this.props.test.sections[this.state.activeSection].name}
                                                                   onChange={(e) => {
                                                                    
                                                                    this.props.updateSectionField(this.state.activeSection, 'name', e.target.value);
                                                                   }}
                                                                    placeholder="Name"
                                                                />
                                                                <br />
                                                                
                                                                {this.renderSectionInstructions()}
                                                                <br />
                                                                {this.state.test &&
                                                                this.state.test.testLocation === 'diagnostic' &&
                                                                    <select className="form-control"
                                                                            onChange={(e) => {
                                                                                let name = this.state.activeCourse.CourseSubject.filter(s => s.id === e.target.value)[0].name;
                                                                                this.props.updateSectionField(this.state.activeSection, 'name', name);
                                                                                this.props.updateSectionField(this.state.activeSection, 'subjectId', e.target.value);
                                                                            }}
                                                                            value={this.props.test.sections[this.state.activeSection].subjectId || ''}
                                                                    >
            
                                                                        <option value={""}>Subject</option>
                                                                        {this.state.activeCourse.CourseSubject.map(sub => {
                                                                            return <option value={sub.id}>{sub.name}</option>
                                                                        })}
                                                                    </select>
                                                                }
                                                                {["mcat"].indexOf(this.props.test.testType) > -1 &&
                                        
                                               
                                                                    <div className="">
                                                                    {this.props.test.sections[this.state.activeSection].file &&
                                                                        <a target="_blank" href={api.makeFileURL(this.props.test.sections[this.state.activeSection].file, this.props.user.id)}>View PDF</a>
                                                                      
                                                                    }
                                                                    <br />
                                                                        <span className="btn btn-default btn-file">
                                                                            <span className="fileinput-new">
                                                                                <i className="zmdi zmdi-upload"/> &nbsp;
                                                                                {this.props.test.sections[this.state.activeSection].file ?
                                                                                    'Replace PDF'
                                                                                    :
                                                                                    'Upload PDF'
                                                                                }
                                                                            </span>
                                                                            
                                                                            <input
                                                                                type="file"
                                                                                onChange={e => this.uploadSectionFile(e, this.state.activeSection, this.state.activeSection)}
                                                                                accept="application/pdf" 
                                                                            />
                                                                        </span> &nbsp; 
                                                                        
                                                                        {this.props.test.sections[this.state.activeSection].file &&
                                                                            <a href="#nogo" onClick={e => {
                                                                                e.preventDefault();
                                                                                this.props.updateSectionField(this.state.activeSection, 'file', '');
                                                                            }}>Delete PDF</a>
                                                                        }
                                                                    </div>
                                                                 
                                                        }
                                                                
                                                            </div>
                                                        
                                                    </div>



                                                    }
                                                    <br /><br />

                                                    <div className="AddNewTestQuestiosModalWrapper">
                                                        <div className="duplicateablequestion">
                                                            {
                                                                this.props.test.sections &&
                                                                this.renderQuestions(this.props.test.sections)}
                                                        </div>
                                                    </div>
                                                    <br /><br />
                                                    <a
                                                        href="nogo"
                                                        className="btn btn-success"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            const section = this.props.test.sections[this.state.activeSection];
                                                            let last = section.questions[section.questions.length - 1];

                                                            const partial = {
                                                                correctOption: "A"
                                                            };
                                                            if(last){
                                                                if(last.page){
                                                                    partial.page = last.page;
                                                                }
                                                            }
                                                            this.props.addTestQuestion(partial, this.state.activeSection);
                                                        }}
                                                        // onclick="AddMoreQuestionToTheTest(this)"
                                                    >
                                                        <i className="zmdi zmdi-plus-circle"/> &nbsp;
                                                        {this.props.test.sections[this.state.activeSection] &&
                                                        this.props.test.sections[this.state.activeSection].questions.length > 0 ?
                                                            "Add Another Question"
                                                        : "Add a question"}
        
                                                    </a>
                                                    &nbsp; 
                                                    <a
                                                        href="#uploadQuizQuestion"
                                                        data-toggle="modal"
                                                        className="btn btn-default"
                                                        onClick={e => this.setState({showUploadModal: true})}
                                                    >
                                                        <i className="zmdi zmdi-upload"/> &nbsp;
                                                        Upload Questions
                                                    </a>
                                                    </div>
                                                    </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                         {this.state.currentTab === 1 &&
                                <div className="test-bottom-buttons">
                                    <button type="button" className="btn btn-default" onClick={e => {
                                        this.setState({currentTab: 0}, () => {
                                            this.props.resetTestTemplate();
                                        })
                                    }}>Close</button>
                                    &nbsp; 
                                    <button type="button" className="btn btn-success" onClick={this.saveTest}>Save changes</button>
                                </div>

                            }
                    </div>
                </div>
                </section>
                {this.state.showUploadModal &&
                    this.renderUploadModal()
                }
            </div>
        )
    }
}

export default withRouter(EditTest);


// WEBPACK FOOTER //
// ./src/components/AdminPanel/EditTest.js